import { getFeedbackAreasForSelection } from './getFeedbackAreasForSelection';

export function getSubjectArea(): string {
    const displayNames = getFeedbackAreasForSelection().map(area => area.displayName);
    return displayNames.join(' - ');
}
